import { generateBridge } from '../Utility/GenerateBridge';
import { PlatformErrorCode } from './ErrorCode';
import { AuthPlatform } from 'Bridges/AuthPlatform';

export type ServicesBridgeSync = {
    isSignedIn: () => boolean;
    getUserId: () => string;
    getFacebookAuthToken: () => string;
    getFacebookAppScopedId: () => string;
    isFacebookConnected: () => boolean;
    getFacebookData: () => IFacebookUser;
    setFacebookData: (data: IFacebookUser) => void;
    getGooglePlayName: () => string;
};

export type ServicesBridgeAsync = {
    signInSilently: (platform: AuthPlatform) => Promise<IAuthReturnValues>;
    signIn: (platform: AuthPlatform) => Promise<IAuthReturnValues>;
    signOut: () => Promise<boolean>;
};

export interface IAuthReturnValues {
    success: boolean;
    appScopedId: string;
    token: string;
    errorCode: PlatformErrorCode;
}

export interface IFacebookUser {
    id: string;
    name: string;
    avatar: string;
}

export const Services = generateBridge({
    name: 'Services',
    sync: {
        getUserId: undefined,
        isSignedIn: undefined,
        getFacebookAuthToken: undefined,
        getFacebookAppScopedId: undefined,
        isFacebookConnected: undefined,
        getFacebookData: undefined,
        setFacebookData: undefined,
        getGooglePlayName: undefined,
    },
    async: {signIn: undefined, signInSilently: undefined, signOut: undefined},
    event: {},
});
